import { trapOn as _, trapOff as q } from "./traps.js";
import { getEventTarget as A } from "./utils.js";
function B() {
  if (typeof window == "undefined")
    return {
      on: () => {
      },
      off: () => {
      }
    };
  const h = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap();
  function M() {
    h.set(this, !0);
  }
  function S() {
    h.set(this, !0), H.set(this, !0);
  }
  function v(n, e, t) {
    const r = n[e];
    return n[e] = function() {
      return t.apply(n, arguments), r.apply(n, arguments);
    }, n;
  }
  function m(n, e) {
    n[e] = Event.prototype[e];
  }
  const E = /* @__PURE__ */ new WeakMap(), T = Object.getOwnPropertyDescriptor(Event.prototype, "currentTarget");
  function U() {
    var n;
    return (n = E.get(this)) !== null && n !== void 0 ? n : null;
  }
  function P(n, e) {
    T !== void 0 && Object.defineProperty(n, "currentTarget", {
      configurable: !0,
      enumerable: !0,
      get: e != null ? e : T.get
    });
  }
  const w = {
    bubble: {},
    capture: {}
  }, c = {};
  function x() {
    const n = function(e) {
      const { type: t, eventPhase: r, bubbles: o } = e, d = A(e);
      if (r === 2)
        return;
      const s = r === 1 ? "capture" : "bubble";
      let i = d;
      const a = [];
      for (; i === null && (i = window), a.push(i), i !== window; )
        i = i.parentNode || null;
      const u = w.capture[t], l = w.bubble[t];
      if (v(e, "stopPropagation", M), v(e, "stopImmediatePropagation", S), P(e, U), s === "capture") {
        if (u === void 0)
          return;
        for (let f = a.length - 1; f >= 0 && !h.has(e); --f) {
          const p = a[f], g = u.get(p);
          if (g !== void 0) {
            E.set(e, p);
            for (const b of g) {
              if (H.has(e))
                break;
              b(e);
            }
          }
          if (f === 0 && !o && l !== void 0) {
            const b = l.get(p);
            if (b !== void 0)
              for (const N of b) {
                if (H.has(e))
                  break;
                N(e);
              }
          }
        }
      } else if (s === "bubble") {
        if (l === void 0)
          return;
        for (let f = 0; f < a.length && !h.has(e); ++f) {
          const p = a[f], g = l.get(p);
          if (g !== void 0) {
            E.set(e, p);
            for (const b of g) {
              if (H.has(e))
                break;
              b(e);
            }
          }
        }
      }
      m(e, "stopPropagation"), m(e, "stopImmediatePropagation"), P(e);
    };
    return n.displayName = "evtdUnifiedHandler", n;
  }
  function z() {
    const n = function(e) {
      const { type: t, eventPhase: r } = e;
      if (r !== 2)
        return;
      const o = c[t];
      o !== void 0 && o.forEach((d) => d(e));
    };
    return n.displayName = "evtdUnifiedWindowEventHandler", n;
  }
  const k = x(), W = z();
  function j(n, e) {
    const t = w[n];
    return t[e] === void 0 && (t[e] = /* @__PURE__ */ new Map(), window.addEventListener(e, k, n === "capture")), t[e];
  }
  function D(n) {
    return c[n] === void 0 && (c[n] = /* @__PURE__ */ new Set(), window.addEventListener(n, W)), c[n];
  }
  function O(n, e) {
    let t = n.get(e);
    return t === void 0 && n.set(e, t = /* @__PURE__ */ new Set()), t;
  }
  function I(n, e, t, r) {
    const o = w[e][t];
    if (o !== void 0) {
      const d = o.get(n);
      if (d !== void 0 && d.has(r))
        return !0;
    }
    return !1;
  }
  function C(n, e) {
    const t = c[n];
    return !!(t !== void 0 && t.has(e));
  }
  function y(n, e, t, r) {
    let o;
    if (typeof r == "object" && r.once === !0 ? o = (u) => {
      L(n, e, o, r), t(u);
    } : o = t, _(n, e, o, r))
      return;
    const s = r === !0 || typeof r == "object" && r.capture === !0 ? "capture" : "bubble", i = j(s, n), a = O(i, e);
    if (a.has(o) || a.add(o), e === window) {
      const u = D(n);
      u.has(o) || u.add(o);
    }
  }
  function L(n, e, t, r) {
    if (q(n, e, t, r))
      return;
    const d = r === !0 || typeof r == "object" && r.capture === !0, s = d ? "capture" : "bubble", i = j(s, n), a = O(i, e);
    if (e === window && !I(e, d ? "bubble" : "capture", n, t) && C(n, t)) {
      const l = c[n];
      l.delete(t), l.size === 0 && (window.removeEventListener(n, W), c[n] = void 0);
    }
    a.has(t) && a.delete(t), a.size === 0 && i.delete(e), i.size === 0 && (window.removeEventListener(n, k, s === "capture"), w[s][n] = void 0);
  }
  return {
    on: y,
    off: L
  };
}
const { on: J, off: K } = B();
export {
  K as off,
  J as on
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/evtd@0.2.4/~/evtd/es/delegate.js
// module id = 60
// module chunks = 41